module.exports = __webpack_public_path__ + "img/公司介绍底图.db6a9d35.png";